/**
 * Pins per room. The one place this number lives on the page. Kyu, 26 Sept
 * ~17:25 (KYU_DECISION.txt:43) set 25, replacing the design's 10; the
 * database guard message_pins_guard refuses the 26th with 'room_pins_full'
 * (Dev3, t_8aadbac2). Change both together or neither.
 */
export const PIN_LIMIT = 25;

/** The hint under a greyed Pin, exactly as Shiroe ruled on t_3cb4c524. */
export const PIN_FULL_HINT = `Unpin one first (max ${String(PIN_LIMIT)})`;
